import React from 'react';
import { StandardPdfTemplate } from '../../templates/StandardPdfTemplate';
import { ProjectData, ProjectInfoData } from '../../shared/types/PdfCommonTypes';
import { GeoGridPdfProps, GeoGridCoreProps, PDFDynamicProject, PDFProjectInfo, SupportedProjectType } from '../../shared/types/PdfTypedInterfaces';

interface UnifiedGeoGridPdfV2Props extends GeoGridPdfProps {
    coreComponent: React.ComponentType<GeoGridCoreProps>;
    customTitle?: string;
    customProjectType?: string;
    customSubtitle?: string;
    defaultProjectType?: SupportedProjectType;
}

const UnifiedGeoGridPdfV2: React.FC<UnifiedGeoGridPdfV2Props> = ({
    dynamicProject,
    projectInfo,
    t,
    geoGridData,
    geogridImage,
    coreComponent: CoreComponent,
    customTitle,
    customProjectType,
    customSubtitle,
    defaultProjectType = 'container_yard',
}) => {
    const unitSystem = dynamicProject.data.unit;
    const projectType = dynamicProject.data.type || defaultProjectType;

    // Extract project information
    const projectData = dynamicProject.data;
    const projectInfoData = projectData.projectInfo;
    const projectMapImage = projectData.mapImage;

    // Prepare data for StandardPdfTemplate
    const projectDataForTemplate: ProjectData = {
        projectName: projectData.projectName || 'N/A',
        projectType: projectType,
        unit: unitSystem,
        mapImage: projectMapImage,
    };

    const projectInfoDataForTemplate: ProjectInfoData = {
        data: {
            nrProject: projectInfo.nrProject || projectInfoData?.data?.nrProject || 'N/A',
        },
        projectOwner: projectInfo.projectOwner || projectInfoData?.projectOwner || 'N/A',
        designerFirmName: projectInfo.designerFirmName || projectInfoData?.designerFirmName || 'N/A',
        designerFirmCountry: projectInfo.designerFirmCountry || projectInfoData?.designerFirmCountry || 'N/A',
        designerFirmCity: projectInfo.designerFirmCity || projectInfoData?.data?.designerFirmCity || 'N/A',
        coordinates: projectInfo.coordinates || projectInfoData?.coordinates || [null, null],
    };

    // Determine header title based on project type and custom override
    const getHeaderTitle = () => {
        if (customTitle) return customTitle;

        switch (projectType) {
            case 'airport':
                return 'MACREAD - design Technical Report';
            case 'railway':
                return 'MACREAD - design Technical Report';
            case 'container_yard':
            case 'unpaved':
                return 'MACREAD - GEOGRID STUDIO';
            default:
                return 'MACREAD - design Technical Report';
        }
    };

    return (
        <StandardPdfTemplate
            projectType={projectType}
            projectData={projectDataForTemplate}
            projectInfoData={projectInfoDataForTemplate}
            t={t}
            headerConfig={{
                customTitle: getHeaderTitle(),
                customProjectType: customProjectType,
                customSubtitle: customSubtitle,
                showGeogridSubtitle: !customSubtitle,
            }}
            footerConfig={{
                customText: t('pdf_footer') || 'MACread eDesign',
                customNotice: t('pdf_footer_notice') || 'Footer notice',
            }}
            showProjectInfo={true}>
            <CoreComponent
                geoGridData={geoGridData}
                geogridImage={geogridImage}
                projectData={projectData}
                t={t}
                showInputData={true}
                showGeoGridImage={true}
                showCourseResults={true}
                customTitle={customTitle}
            />
        </StandardPdfTemplate>
    );
};

export default UnifiedGeoGridPdfV2;
